<script lang="ts" setup>
  import { ShopItemEditor } from '@/features/shop/editItem'

  definePage({
    meta: {
      layout: 'baseNew',
      shopManagerRoute: true,
    },
  })

  const { t } = useI18n()
  const router = useRouter()

  useHead({
    title: t('shop_create_item_page_title'),
  })

  const handleSaved = (productId: number) => {
    router.push({ name: '/shop/item/[id]/edit/', params: { id: productId } })
  }

  const handleCancel = () => {
    router.push({ name: '/shop/' })
  }

  const handleSubmitFailed = () => {
    router.push({ name: '/shop/' })
  }

  const handleStockSaveFailed = (productId: number) => {
    router.push({ name: '/shop/item/[id]/edit/', params: { id: productId } })
  }
</script>

<template>
  <ShopItemEditor
    mode="create"
    @saved="handleSaved"
    @cancel="handleCancel"
    @stock-save-failed="handleStockSaveFailed"
    @submit-failed="handleSubmitFailed"
  />
</template>
